import React from 'react';
import PropTypes from 'prop-types';
import InputField from '../../Form/TextFields/InputField';
import Checkbox from '../../Form/Checkbox/Checkbox';
import Button from '../../Form/Buttons/Button';
import Modal from '../Modal';
import classes from './noteModal.module.scss';
import Select from '../../Form/Selects/Select/Select';
import DOBPicker from '../../Form/DatePickers/DOBPicker/DOBPicker';
import TimePicker from '../../Form/DatePickers/TimePicker/TimePicker';
import accountHelpers from '../../../../utils/accountHelpers';

const NoteModal = ({
  isOpenModal, onClose, noteData = {}, onChangeNoteData, saveNote, saveLoading,
  selectNote = [], onChangeSelect, selectOption = '', showSelect,
  group, showCheckbox, showDateTime, noteDate = {}, dateError = {},
  onChangeDate,
}) => {
  const isPatient = accountHelpers.isInOneOfRoles(['Patient']);

  const { note = '', privateBody = false, noteId = '' } = noteData;

  return (
    <Modal
      open={isOpenModal}
      onClose={onClose}
      className={classes.doc_modal}
    >
      <div className={classes.add_modal_wrapper}>
        <h2>{noteId ? 'Edit note' : 'Add note'}</h2>

        <div>
          {showDateTime && (
          <div className={classes.date_wrapper}>
            <DOBPicker
              wrapperClassName={classes.date_picker}
              label="Date"
              hideClearButton
              date={noteDate.date}
              dateFormat="YYYY/MM/DD"
              onChange={(value) => onChangeDate('date', value)}
              autoValidation={false}
              error={dateError.date}
            />

            <TimePicker
              wrapperClassName={classes.time_picker}
              label="Time"
              hideClearButton
              time={noteDate.time}
              onChange={(value) => onChangeDate('time', value)}
              autoValidation={false}
              error={dateError.time}
            />
          </div>
          )}

          <div className={classes.textarea_note}>
            <InputField
              onChange={(value) => onChangeNoteData('note', value)}
              textareaField
              value={note}
            />
          </div>

          {!group && showSelect && (
          <div className={classes.select_note}>
            <Select
              label="Select Relevant Visit"
              options={selectNote}
              zIndex={31}
              currentOption={selectOption}
              onChange={(option) => onChangeSelect(option)}
              optionRenderPath="value"
            />
          </div>
          )}

          {showCheckbox && !isPatient && (
            <Checkbox
              label="Make private"
              onChange={(checked) => onChangeNoteData('privateBody', checked)}
              checked={privateBody}
            />
          )}
        </div>

        <div className={classes.btn_wrapper}>
          <Button
            title="Cancel"
            type="button"
            onClick={onClose}
            clearButton
          />

          <Button
            title={noteId ? 'Save' : 'Add note'}
            type="button"
            loading={saveLoading}
            onClick={saveNote}
          />
        </div>
      </div>
    </Modal>
  );
};

NoteModal.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  noteData: PropTypes.object,
  onChangeNoteData: PropTypes.func,
  showSelect: PropTypes.bool,
  showCheckbox: PropTypes.bool,
  showDateTime: PropTypes.bool,
  noteDate: PropTypes.object,
  dateError: PropTypes.object,
  onChangeDate: PropTypes.func,
  group: PropTypes.bool,
  saveLoading: PropTypes.bool,
  saveNote: PropTypes.func.isRequired,
  onChangeSelect: PropTypes.func,
  selectNote: PropTypes.array,
  selectOption: PropTypes.string,
};

export default NoteModal;
